
import React from "react";


const SectionHeading = ({heading}) => {

  return (
    <>
      <div className="sectionHeading"> {heading}</div>
    </>
  );
};

export default SectionHeading;
